<template>
    <section>
        <div class="page-wrap">
            <div class="container">
                <div class="box-content stories">
                    <share-story hr="none"></share-story>
                    <h2 class="crossline-title text-center">Featured Stories</h2>
                    <!--<div class="row">
                        <div class="col-sm-12">
                            <h3>
								Submit your story to be featured here!
							</h3>
                        </div>
					</div>--> 
					<div class="row">
						<!-- Story # 1 Line 2 -->
                        <div class="col-sm-4">
                            <h3>Sharon Hightower</h3>
                            <div class="img-box">
                                <!--<div class="img-wrap">
                                    <img src="images/story02.jpeg" alt="">
                                </div>-->
                            </div> 
                            <p class="text-left">
								My husband, Jim, taught at CSUF (Quantitative Methods, Business, Computer Science) for many decades. It was, indeed, his home away from home.
							</p>
                        </div>
						<!-- Story # 2 Line 3 -->
                        <div class="col-sm-4">
                            <h3>MehdiReza Hirji</h3>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story-numhb.jpeg" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                I graduated from CSUF in 2000 in Accounting and Finance. For the last 20 years, I've worked with various companies reach its strategic and financial goals. Learning never stops and I realized that going after knowledge is better than going after wealth (in itself). You can keep account of wealth because it is limited, but you cannot keep account of knowledge because it is boundless. That is why knowledge is better than wealth. Knowledge illuminates the mind.
							</p>
                        </div>
						<!-- Story # 3 Line 4 -->
						<div class="col-sm-4">
                            <h3>Victoria Valenzuela</h3>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story-IHmLk.png" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                My name is Victoria (Tory) Valenzuela and I was a President's Scholar at CSUF from 1991-1995. I majored in Political Science with a minor in Speech Communication. I am forever grateful for my experience and the education I received while at CSUF. After graduation, I went on to attend Stanford Law School, and I credit my success there to my work at CSUF. I've practiced law for over 21 years now and am currently the Chief Legal Officer at AppLovin Corporation, who I helped take public in April of 2022! Fight on Titans!!!
                            </p>
                        </div>
                    </div>
					<div class="row">
						<!-- Story # 1 Line 2 -->
                        <div class="col-sm-4">
                            <h3>Bob Ericksen</h3>
                            <div class="img-box">
                                <!--<div class="img-wrap">
                                    <img src="images/story02.jpeg" alt="">
                                </div>-->
                            </div> 
                            <p class="text-left">
								The individuals I am honoring here are all colleagues I worked with at CSUF, where I served as Director of International Education and Exchange from 1984-2006.  Each of them played a pivotal role in advancing academic and personal support for refugee, immigrant and international students.   Each was devoted to making CSUF a place where diverse students are welcomed and BELONG.  Dogan Cuceloglu passed last year and was honored with a national funeral in Turkey, where he returned after retirement.  Dr. Oaks was killed in an accident the week we were to launch the Partners program, her brainchild.  Dr. Son Vo enjoys an active retirement after her many years work with the CSUF Intercultural Development Center.  These people are my heroes!  I hope their pavers can be placed near one another.
							</p>
                        </div>
						<!-- Story # 2 Line 3 -->
                        <div class="col-sm-4">
                            <h3>Edison Lim</h3>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story-Lvz7q.jpeg" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                Cal State Fullerton holds a special place in our family's heart. From getting my Master's in computer science, to enrolling my children every summer at CSUF's swimming program and Titan Youth Sports Camp, I am proud to say that my daughter has followed in my footsteps, graduating from CSUF in 2018 with her BSN degree. CSUF's diversity, exemplary leadership, and student engagement have made her a strong, well-rounded nurse who is serving our community well during this pandemic and who is now pursuing her Doctorate in Family NP degree at Duke University. Thank you, CSUF, for all you do for your students. A special shoutout to the President's Scholars, who have shaped my daughter into the person and nurse she is today, and to the Lord, through whom all wisdom has come. Titans Reach Higher!
							</p>
                        </div>
						<!-- Story # 3 Line 4 -->
						<div class="col-sm-4">
                            <h3>Casey Higgins</h3>
                            <div class="img-box">
                                <!--<div class="img-wrap">
                                    <img src="images/story3.jpeg" alt="">
                                </div>-->
                            </div>
                            <p class="text-left">
                                In several ways, Cal State Fullerton has been a big part of our lives. My wife and I both grew up in the area nearby and Marcia graduated from the Psychology Department. She never imagined during some difficult times as an undergraduate that she might someday be in a position to give back to the university and have paver with her name acknowledging all opportunities that CSUF gave her.  I'm faculty and even my boys have been to many programs and events here that have enriched their lives. Thanks, Cal State Fullerton!
                            </p>
                        </div>
                    </div>
					
					
					
					
					
					
					
					
					
					<div class="row">
						<!-- Story # 1 Line 2 -->
                        <div class="col-sm-4">
                            <h3>Karen Bell</h3>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story02.jpeg" alt="">
                                </div>
                            </div> 
                            <p class="text-left">
								Tony and I felt very at home at Cal State Fullerton.  He served 2 terms as department chair; he was sought after for student advising and his popular class on “Death & Dying.”  We worked in different departments, and ended up sharing long-time friends in each of them.  Highlights were attending many events put on by the visual arts, dance, music, and theatre departments, our strolls on campus, including the Arboretum.  We had 60 wonderful years of marriage together, 3 sons and families, before he died in 2019.<br /><br />Karen
							</p>
                        </div>
						<!-- Story # 2 Line 3 -->
                        <div class="col-sm-4">
                            <h3>Robert Rogers</h3>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story03.jpeg" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                I was the first person in my family to graduate college, and my mother and father were so proud on my graduation day in 2005. I went on to graduate school at UC Berkeley and now work in government in the Bay Area. I have my own family now and hope my children, who are still small, can go to a great university like Cal State Fullerton. My father is gone, but I still cherish the memory of the day he saw me graduate from CSUF, and my mom is still healthy and happy and I can't wait to bring her, and my wife and children, to the campus to see our inscription and absorb the great culture of learning and striving that has always enlivened this beautiful university.
							</p>
                        </div>
						<!-- Story # 3 Line 4 -->
						<div class="col-sm-4">
                            <h3>Joe Albert Garcia</h3>
                            <div class="img-box">
                                <!--<div class="img-wrap">
                                    <img src="images/story3.jpeg" alt="">
                                </div>-->
                            </div>
                            <p class="text-left">
                                In several ways, Cal State Fullerton has been a big part of our lives. My wife and I both grew up in the area nearby and Marcia graduated from the Psychology Department. She never imagined during some difficult times as an undergraduate that she might someday be in a position to give back to the university and have paver with her name acknowledging all opportunities that CSUF gave her.  I'm faculty and even my boys have been to many programs and events here that have enriched their lives. Thanks, Cal State Fullerton!
                            </p>
                        </div>
                    </div>
                    <div class="row">
						<!-- Story # 4 Line 5 -->
                        <div class="col-sm-4">
                            <h3>Bradford Anderson</h3>
                            <div class="img-box">
                                <!--<div class="img-wrap">
                                    <img src="images/story4.jpeg" alt="">
                                </div>-->
                            </div>
                            <p class="text-left">
                                I spent 37 years in sales with Nestle.  Upon early retirement I joined CSUF as the Director of the Sales Leadership Center in the College of Business & Economics.  I used my experience and connections to inspire and guide young people to sales internships and sales careers where they become productive employees of our sponsor companies.  I enjoy working with our students and sponsors to give to the society young people who are prepared for the careers they choose.
							</p>
                        </div>
						<!-- Story # 5 Line 6 -->
                        <div class="col-sm-4">
                            <h3>Kathy Taylor</h3>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story06.jpeg" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                “TANSTAAFL” was written on the board the first day of my economics class.  The professor spent a lot of time explaining how economics work and how nothing comes for free even though the government makes you think so.  Free things are paid for in one way or another through printing money or taxation.
							</p>
                        </div>
						<!-- Story # 6 Line 7 -->
						<div class="col-sm-4">
                            <h3>Juliana Romo</h3>
                            <div class="img-box">
                                <div class="img-box">
									<!--<div class="img-wrap">
										<img src="images/story6.jpeg" alt="">
									</div>-->
								</div>
                            </div>
                            <p class="text-left">
                                With all the odds against us we beat the odds together.
                            </p>
                        </div>
                    </div>
                    <div class="row">
						<!-- Story # 7 Line 8 -->
                        <div class="col-sm-4">
                            <h3>Samantha Horito</h3>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story08.jpeg" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                My fiancé and I met seven years ago as students at Cal State Fullerton. CSUF is where our love story began and we will be getting married in March of 2022. This paver will be a surprise wedding gift for my soon-to-be husband. I can't wait for him to see that a piece of us will forever be a part of the place that means so much to us.
							</p>
                        </div>
						<!-- Story # 8 line 10 -->
                        <div class="col-sm-4">
                            <h3>Ruth Reinkymov</h3>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story10.jpeg" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                My husband and I met as student leaders when we both represented our respective colleges on the ASI ICC. To honor the role of CSUF in our relationship, we married at the Alumni House in 2012 and will take our 10 year anniversary photos at the Arboretum in Spring 2022. We are so grateful for all CSUF has done for us. We are the Reinkymovs. Thanks to the university.
                            </p>
                        </div>
						<!-- Story # 9 line 11 -->
                        <div class="col-sm-4">
                            <h3>Roshan Patel</h3>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story11.jpeg" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                My father, Sunil, and mother, Minakshi, fled Fiji in 1987 from family urgency due to military coup. They landed in Buena Park  on 10/06/1987. I was born a year later 10/12/1988 had the most beautiful, fun, family-oriented childhood. My father just said make sure you "go to college." I graduated from CSUF College of Business in 2011. Too many great memories from friends and professors and college involvements. Ten years later I'm a millionaire. I'm proud to give back to education. Thank you to the community entirely.
							</p>
                        </div>
                    </div>
                    <div class="row">
						<!-- Story # 10 Line 12 -->
                        <div class="col-sm-4">
                            <h3>Jorge Garduno Rocha</h3>
                            <div class="img-box">
                                <div class="img-wrap">
									<img src="images/story12.png" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                Cal State Fullerton provided the opportunity for me to advance my education in a challenging yet rewarding experience. Engraved in this message are the famous words of the civil rights icon, Dolores Huerta. “Si se puede!” For a first-generation Latino male like myself, the graduation rates for a master’s degree for others like me are extremely low. Because of this, my accomplishment is a significant milestone. I hope to inspire the future generation of leaders and encourage everyone to take risks, learn from their mistakes, and dare to be legendary. No matter what level of education is being pursued, I want students to know that there is someone out there that believes in them.
							</p>
							<p>
								I want to give a special shout out to Cohort 12 from the Master’s of Science in Higher Education, and the faculty and staff that supported us along the way. I could not have made it this far without your support.
                            </p>
                        </div>
						<!-- Story # 11 -->
						<div class="col-sm-4">
                            <h3>Carl Gill</h3>
                            <div class="img-box">
                                <div class="img-wrap">
									<img src="images/story13.png" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                 This was a journey for Carolyn Gill. Our only daughter, and our son's only sister, would head off to college to not only earn her degrees, but also to play basketball. It was like working two-and-a-half full-time jobs.
							</p>
							<p>
								It wasn't easy, and during the most challenging times of this journey, when others had given up and she wanted to too, her only solace was that God had given her a plan and purpose for her life, which she had to take one day at a time, one step at a time.
							</p>
							<p>
								Carolyn's dad would send her inspirational and motivational messages almost daily. And at the end of each message, he would say, "Stay blessed today," meaning she needed to remind herself that she was already blessed and no matter what steps she had to take today, the fact that she was here taking the very next step was evidence that all she had to do at the end of the day was exhale, be thankful, get rest, and get up the next day.
							</p>
							<p>
								She did it, and we are all so very proud of Carolyn Gill, BA, MBA 2022.
                            </p>
                        </div>
						<!-- Story # 12 Line 14 -->
						<div class="col-sm-4">
                            <h3>Tony Atlas</h3>
                            <div class="img-box">
                                <div class="img-wrap">
									<img src="images/story14.jpeg" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                Cal State Fullerton was the bridge and foundation for my success in life. I am proud to have been involved with Cal State Fullerton athletics and academics. 
							</p>
                        </div>
                    </div>
					<div class="row">
						<!-- Story # 1 Line 2 -->
                        <div class="col-sm-4">
                            <h3>Lisa Poole</h3>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story-rfxp1.jpeg" alt="">
                                </div>
                            </div> 
                            <p class="text-left">
								Rick M. Poole graduated in accounting from Cal State Fullerton. He went on to obtain his C.P.A. and became a partner at Stonefield Josephson (now Marcum) just prior to his passing on July 4 , 2008.  He was only 43 but left a huge impact on colleagues and all who knew him.
							</p>
							<p>
								Rick was a member of the Executive Counsel at CSUF's business school and actively recruited Cal State Fullerton graduates.
							</p>
							<p>
								He was always optimistic and respected for his kindness and generosity.
							</p>
							<p>
								He is greatly missed by his wife, children, friends and family. We thank Cal State Fullerton for providing an opportunity to honor his memory.
							</p>
                        </div>
						<!-- Story # 2 Line 3 -->
                        <div class="col-sm-4">
                            <h3>Blake Street</h3>
                            <div class="img-box">
                                <!--<div class="img-wrap">
                                    <img src="images/story-Lvz7q.jpeg" alt="">
                                </div>-->
                            </div>
                            <p class="text-left">
                                Cal State Fullerton is a lifelong investment that continues to deliver unanticipated rewards. From birthing a passion and career in Financial Planning, to providing me an opportunity to pay forward my success and privilege. The school has afforded me lifelong friendships, mentors, and most of all teammates on the battlefield in business.
							</p>
                        </div>
						<!-- Story # 3 Line 4 -->
						<div class="col-sm-4">
                            <h3>&nbsp;</h3>
                            <div class="img-box">
                                <!--<div class="img-wrap">
                                    <img src="images/story-rfxp1.jpeg" alt="">
                                </div>-->
                            </div>
                            <p class="text-left">
                                &nbsp;
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/jsx">
    import ShareStory from '@/components/ShareStory.vue';
    export default {
        name: 'stories',
        components: {
            'share-story': ShareStory
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// Stories.vue?34e505c9